import { apiRequest } from "./client";
import type { NotificationDto, NotificationPreferencesDto } from "./types";

export const getMyNotifications = (token: string): Promise<NotificationDto[]> =>
	apiRequest<NotificationDto[]>("/notifications", { token });

export const markNotificationsRead = (token: string): Promise<void> =>
	apiRequest<void>("/notifications/mark-read", { method: "POST", token });

/** Marks a single notification read (true) or unread (false). */
export const setNotificationRead = (id: string, isRead: boolean, token: string): Promise<void> =>
	apiRequest<void>(`/notifications/${id}/read`, { method: isRead ? "POST" : "DELETE", token });

export const deleteNotification = (id: string, token: string): Promise<void> =>
	apiRequest<void>(`/notifications/${id}`, { method: "DELETE", token });

export const getNotificationPreferences = (token: string): Promise<NotificationPreferencesDto> =>
	apiRequest<NotificationPreferencesDto>("/notifications/preferences", { token });

export const updateNotificationPreferences = (
	payload: NotificationPreferencesDto,
	token: string
): Promise<NotificationPreferencesDto> =>
	apiRequest<NotificationPreferencesDto>("/notifications/preferences", { method: "PUT", body: payload, token });
